import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42e69ec4")

_pushScopeId("data-v-42e69ec4")
const _hoisted_1 = { class: "chart-data-editor" }
const _hoisted_2 = { class: "editor-content" }
const _hoisted_3 = { class: "range-box" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "temp-range",
          style: {
            width: _ctx.tempRangeSize.width + 'px',
            height: _ctx.tempRangeSize.height + 'px',
          }
        }, null, 4),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rangeLines, (line) => {
          return (_openBlock(), _createBlock("div", {
            class: ['range-line', line.type],
            key: line.type,
            style: line.style
          }, null, 6))
        }), 128)),
        _createVNode("div", {
          class: "resizable",
          style: _ctx.resizablePointStyle,
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeSelectRange($event)), ["stop"]))
        }, null, 36)
      ]),
      _createVNode("table", null, [
        _createVNode("tbody", null, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(30, (rowIndex) => {
            return _createVNode("tr", { key: rowIndex }, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (colIndex) => {
                return _createVNode("td", {
                  key: colIndex,
                  class: { 'head': colIndex === 1 && rowIndex <= _ctx.selectedRange[1] }
                }, [
                  _createVNode("input", {
                    class: ['item', { 'selected': rowIndex <= _ctx.selectedRange[1] && colIndex <= _ctx.selectedRange[0] }],
                    id: `cell-${rowIndex - 1}-${colIndex - 1}`,
                    autocomplete: "off"
                  }, null, 10, ["id"])
                ], 2)
              }), 64))
            ])
          }), 64))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeEditor()))
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "primary",
        class: "btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTableData()))
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
})